import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { differenceInMinutes, parseISO } from "date-fns";

/**
 * Returns the scheduled duration of a shift in minutes
 * Uses the shift's start and end times (not actual clocked times)
 */
export function getScheduledShiftDurationInMinutes(shift: Pick<Shift, "start" | "end">): number {
  return differenceInMinutes(parseISO(shift.end), parseISO(shift.start));
}
